import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Checkbox,
    Button,
    Flex,
    Tag,
    HStack,
    Divider,
  } from "@chakra-ui/react";
  import { CalendarX, Check, CheckCheck, CirclePlus, Clock, Loader, X } from "lucide-react";
  import useCustomTheme from "../../hooks/useCustomTheme";
  
  const TableFilters = ({ filters, setFilters, filterOptions, labelMap }) => {

    const { theme } = useCustomTheme();

    const handleToggle = (category, value) => {
      const current = filters[category] || [];
      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];
  
      setFilters((prev) => ({
        ...prev,
        [category]: updated,
      }));
    };
  
    const handleClearCategory = (category) => {
      setFilters((prev) => ({
        ...prev,
        [category]: [],
      }));
    };
  
    const handleClearAll = () => {
      setFilters({});
    };
    

    const getOptionIcon = (category, option) => {
      if (category === "status") {
        if (option === "to review") return <Loader size={14} style={{ marginRight: 8 }} color={theme.colors.grey[500]} />;
        if (option === "validated") return <Check size={14} style={{ marginRight: 8 }} color={theme.colors.grey[500]} />;
        if (option === "Completed") return <CheckCheck size={14} style={{ marginRight: 8 }} color={theme.colors.grey[500]} />;
        if (option === "Pending") return <Clock size={14} style={{ marginRight: 8 }} color={theme.colors.grey[500]} />;
        if (option === "Overdue") return <CalendarX size={14} style={{ marginRight: 8 }} color={theme.colors.grey[500]} />;
        if (option === "Approved") return <CheckCheck size={14} style={{ marginRight: 8 }} color={theme.colors.grey[500]} />;

      }
      return null;
    };
  
    return (
      <Flex gap={2} wrap="wrap" align="center">
        {Object.entries(filterOptions).map(([category, options]) => {
          const selected = filters[category] || [];
  
          return (
            <Menu closeOnSelect={false} key={category}>
              <MenuButton
                as={Button}
                variant="ghost"
                color={"grey.700"}
                border={"1px dashed"}
                borderColor={"grey.200"}
                size="sm"
                h="32px"
                gap={1}
                leftIcon={<CirclePlus size={16} color={theme.colors.grey[500]} />}
                fontWeight={500}
              >
                <HStack spacing={1} wrap="wrap">
                  <span>{labelMap[category]}</span>
                  {selected.length > 0 && (
                    <>
                      <Divider orientation="vertical" height="16px" mx={2} />
                      {selected.length === 1 ? (
                        <Tag size="sm" textTransform={"capitalize"} fontSize={"12px"} fontWeight={400}>{selected[0]}</Tag>
                      ) : (
                        <Tag size="sm" fontSize={"12px"} fontWeight={400}>{selected.length} selected</Tag>
                      )}
                    </>
                  )}
                </HStack>
              </MenuButton>
  
              <MenuList p={1}>
                {options.map((option) => (
                  <MenuItem
                    key={option}
                    closeOnSelect={false}
                    justifyContent="flex-start">
                    <Checkbox
                      isChecked={selected.includes(option)}
                      onChange={() => handleToggle(category, option)}
                      display="flex"
                      alignItems="center"
                      gap={2}>
                      <Flex align="center">
                        {getOptionIcon(category, option)}
                        <span style={{ textTransform: "capitalize" }}>{option}</span>
                      </Flex>
                    </Checkbox>
                  </MenuItem>
                ))}
  
                {selected.length > 0 && (
                  <>
                    <Divider my={1} />
                    <MenuItem
                      as={Button}
                      size="sm"
                      fontWeight={400}
                      variant="ghost"
                      border={"none"}
                      _hover={{ bg: "gray.100" }}
                      onClick={() => handleClearCategory(category)}
                    >
                      Clear filters
                    </MenuItem>
                  </>
                )}
              </MenuList>
            </Menu>
          );
        })}
  
        {/* Reset all filters */}
        {Object.values(filters).some((v) => v.length > 0) && (
          <Button
            onClick={handleClearAll}
            variant="ghost"
            border={"none"}
            color="var(--grey700)"
            fontWeight={400}
            size="sm"
            gap={1}
            rightIcon={<X size={16} color={theme.colors.grey[700]} />}
          >
            Reset
          </Button>
        )}
      </Flex>
    );
  };
  
  export default TableFilters;